import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

const Footer = props => {
  return (
    <div className="Footer">
      <p>
        made with <FontAwesomeIcon style={{ color: "red" }} icon={faHeart} /> by
        Koen
      </p>
      <p style={{ textAlign: "center" }}>
        Icons made by{" "}
        <a
          style={{ textDecoration: "underline", color: "#000" }}
          href="https://www.freepik.com/?__hstc=57440181.7c873a3b88cc865021252651a5ec0003.1561456448306.1561456448306.1563881748217.2&__hssc=57440181.2.1563881748217&__hsfp=611840125"
          title="Freepik"
        >
          Freepik
        </a>{" "}
        from{" "}
        <a
          style={{ textDecoration: "underline", color: "#000" }}
          href="https://www.flaticon.com/"
          title="Flaticon"
        >
          www.flaticon.com
        </a>
        <br />
        is licensed by{" "}
        <a
          style={{ textDecoration: "underline", color: "#000" }}
          href="http://creativecommons.org/licenses/by/3.0/"
          title="Creative Commons BY 3.0"
          target="_blank"
          rel="noopener noreferrer"
        >
          CC 3.0 BY
        </a>
      </p>
    </div>
  );
};

export default Footer;
